import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["totalUnits", "weightValue", "weightUnit", "weightDisplay"];

  connect() {
    // Calculate initial weight if values are present
    this.calculateWeight();
  }

  updateCapacity(event) {
    // Calculate weight when harvest unit changes
    this.calculateWeight();
  }

  calculateWeight() {
    // Find the combobox hidden input by its name
    const harvestUnitInput = this.element.querySelector(
      'input[name="harvest_schedule[harvest_unit_id]"]'
    );
    const harvestUnitId = harvestUnitInput ? harvestUnitInput.value : null;
    const totalUnits = parseInt(this.totalUnitsTarget.value) || 0;

    if (!harvestUnitId || totalUnits === 0) {
      this.weightValueTarget.textContent = "0";
      this.weightUnitTarget.textContent = "kg";
      // Don't hide it, just show 0
      return;
    }

    // Find the hidden div with harvest unit data
    const unitDataElement = this.element.querySelector(
      `[data-harvest-unit-id="${harvestUnitId}"]`
    );

    if (unitDataElement) {
      const capacityValue = parseFloat(unitDataElement.dataset.capacityValue);
      const capacityUnit = unitDataElement.dataset.capacityUnit;

      const totalWeight = (capacityValue * totalUnits).toFixed(2);

      this.weightValueTarget.textContent = totalWeight;
      this.weightUnitTarget.textContent = capacityUnit;
    } else {
      console.log("No unit data element found for ID:", harvestUnitId);
    }
  }
}
